import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useOrganization } from '@/contexts/organization-context'
import { billingService } from '@/services/billing'
import { BillingBlockedScreen } from '@/components/billing-blocked-screen'

/**
 * Standalone "upgrade required" page, in the spirit of the /get-started/* pages.
 *
 * Lives OUTSIDE <SubscriptionGuard> on purpose — the guard redirects here, so a
 * guarded route would loop. It only calls ungated billing endpoints (/billing/usage,
 * /billing/subscription-info, checkout, upgrade), never a gated one, so it renders
 * cleanly for an org the api is otherwise 403-ing.
 *
 * Once the org is no longer blocked (upgrade approved, or cube volume recomputed),
 * it bounces the user back into the app rather than stranding them here.
 */
export default function UpgradeRequiredPage() {
  const navigate = useNavigate()
  const { currentOrganization } = useOrganization()

  useEffect(() => {
    if (!currentOrganization) return
    let cancelled = false
    billingService
      .getUsage()
      .then((usage) => {
        if (cancelled) return
        if (!usage.blocked) navigate(`/${currentOrganization.slug}`, { replace: true })
      })
      .catch(() => {
        /* leave the page up; the CTA still works */
      })
    return () => {
      cancelled = true
    }
  }, [currentOrganization?.slug, navigate])

  return (
    <div className="min-h-screen bg-background">
      <BillingBlockedScreen />
    </div>
  )
}
